module.exports = __webpack_public_path__ + "static/media/HCMM248.867bedcf.jpg";